const permissionGroup = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_PERMISSION_GROUPS_SUCCESS':
      return action.permissionGroup;
    default:
      return state;
  }
};

export default permissionGroup;
